export default function genererCompetenceFournisseur() {
  return {
    competenceFournisseurId: null,
    competenceFournisseur: null,
  };
}
